import { WidgetHelper } from "app/helpers/widgetHelper";
import GeniusWidget from "app/screens/EventsScreen/screens/CompetitionsScreen/components/UnsummarizedMarketsScreen/components/GeniusWidget/GeniusWidget";
import { EventType, WidgetData } from "app/types/eventType";
import { widgetProviders } from "app/utils/const";
import BetradarWidgetMobile from "./BetradarWidgetMobile";

type Props = {
  widgets: WidgetData;
  widgetExpanded: boolean;
  showHomePlayerAsFirst: boolean;
  darkMode: boolean;
  sportType: string;
  event: EventType;
};
const EventInfoWidget = ({
  widgets,
  widgetExpanded,
  showHomePlayerAsFirst,
  darkMode,
  sportType,
  event,
}: Props) => {
  const provider = widgets?.widgetProvider;
  const sourceFixtureId = WidgetHelper.getSourceFixtureId(widgets);
  if (!provider || !sourceFixtureId) {
    return null;
  }

  return (
    <>
      {provider === widgetProviders.BETRADAR && (
        <div className="unsummarized-markets__betradar-widget">
          <BetradarWidgetMobile
            sourceFixtureId={sourceFixtureId}
            widgetExpanded={widgetExpanded}
            event={event}
          />
        </div>
      )}

      {provider === widgetProviders.GENIUSSPORTS && (
        <GeniusWidget
          darkMode={darkMode}
          sportType={sportType}
          sourceFixtureId={sourceFixtureId}
          standAloneSection={widgetExpanded ? "" : "scoreboard"}
        />
      )}
    </>
  );
};

export default EventInfoWidget;
